import axios from 'axios';
import { IResultState } from './resultInterfaces';
import { IAppContext } from '../context/DefaultAppState';
import IDoctorSpecialty from '../interfaces/IDoctorSpecialty';
import IFacilitySpecialty from '../interfaces/IFacilitySpecialty';
import plansData from '../plansData';
import IDentistSpecialty from '../interfaces/IDentistSpecialty';

const getPlanData = async (appContext: IAppContext) => {
  const planUrl = window.location.host;
  //TODO: Undo before deployment
  // const planUrl = 'simpra.com';

  try {
    //const { data } = await axios.get(`/Plans`);
    //const plans = data?.filter((p: any) => p.planSite === planUrl);

    const data = plansData;
    const plans = data;

    if (plans) {
      const plan = plans[0];
      document.documentElement.setAttribute('theme', plan.styleTheme);
      //appContext.updatePlanName(plan.name);
      appContext.updatePlansData(plans);
    }
  } catch (err) {
    console.error(err);
  }
};

// const getTheme = (appContext: IAppContext) => {
//   const planUrl = window.location.host;
//   const plan = plansData.find((pd) => pd.site === planUrl);
//
//   if (plan) {
//     document.documentElement.setAttribute('theme', plan.theme);
//     appContext.updatePlanName(plan.name);
//     appContext.updatePlan(plan);
//     console.log('INIT PLAN: ', plan);
//   }
// };

const getDoctorSpecialties = async (appContext: IAppContext) => {
  try {
    const res = await axios.get(`/DoctorSpecialties`);
    const specialties: IDoctorSpecialty[] = res.data;
    appContext.updateDoctorSpecialties(specialties);
  } catch (err) {
    console.error(err);
  }
};

const getFacilitySpecialties = async (appContext: IAppContext) => {
  try {
    const res = await axios.get(`/FacilitySpecialties`);
    const specialties: IFacilitySpecialty[] = res.data;
    appContext.updateFacilitySpecialties(specialties);
  } catch (err) {
    console.error(err);
  }
};

const getPharmacySpecialties = async (appContext: IAppContext) => {
  try {
    const res = await axios.get(`/PharmacySpecialties`);
    const specialties: string[] = res.data;
    appContext.updatePharmacySpecialties(specialties);
  } catch (err) {
    console.error(err);
  }
};

const getDentistSpecialties = async (appContext: IAppContext) => {
  try {
    const res = await axios.get(`/lookups/Specialties?section=Dentist`);

    const specialties: IDentistSpecialty[] = res.data;
    appContext.updateDentistSpecialties(specialties);
  } catch (err) {
    console.error(err);
  }
};

const getStates = async (appContext: IAppContext) => {
  const emptyStateOption: IResultState = {
    state: 'Pick your state',
    abbreviation: 'default',
    code: 'default'
  };

  try {
    const { data } = await axios.get(`/States`);
    const states = data;
    console.log('STATES REQ: ', states);
    states.unshift(emptyStateOption);
    appContext.updateStateList(states);
  } catch (err) {
    console.error(err);
  }
};

const getCacheTime = async (appContext: IAppContext) => {
  try {
    const { data } = await axios.get(`/CacheTime`);
    appContext.updateCacheTime(data);
  } catch (err) {
    console.error(err);
  }
};

const initializeApp = async (appContext: IAppContext) => {
  await getPlanData(appContext);
  // getTheme(appContext);
  await getCacheTime(appContext);
  await getStates(appContext);
  await getDoctorSpecialties(appContext);
  await getFacilitySpecialties(appContext);
  await getPharmacySpecialties(appContext);
  await getDentistSpecialties(appContext);
  // TODO: Add Loading Complete Update Here
};

export default initializeApp;
